
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparecrmprices/privacy-policy",
      function () {
        return require("private-next-pages/comparecrmprices/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparecrmprices/privacy-policy"])
      });
    }
  